module.exports = __webpack_public_path__ + "img/zhuoliying.e1868006.jpg";